import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AgeAndGenderDistribution, StatisticsAgeSubRow } from '../models/ageAndGenderDistribution';

type StatisticsGenderDistributionDataGridProps = {
  dataList: AgeAndGenderDistribution;
};

export const AgeAndGenderDistributionDataGrid = (props: StatisticsGenderDistributionDataGridProps) => {
  const { dataList } = props;
  const { t } = useTranslation();

  const sumOfSubRow = (r: StatisticsAgeSubRow) => (r.ageSpans ?? []).reduce((tot, s) => tot + (s?.count ?? 0), 0);

  return (
    <>
      {dataList ? (
        <>
          {dataList.rows &&
            dataList.rows.length > 0 &&
            dataList.rows.map((row) => {
              return (
                <Table key={row.id} size='small' aria-label='members-count' sx={{ width: '100%', mb: 4 }}>
                  <TableHead>
                    <TableRow
                      sx={{
                        '& th': { fontWeight: 600, borderBottom: (v) => `1px solid ${v.palette.divider}` },
                      }}
                    >
                      <TableCell align='left'>{row.label}</TableCell>
                      <TableCell align='right'>{t('statistics:ageAndGenderDistribution.gender')}</TableCell>
                      {row.spans &&
                        row.spans.length > 0 &&
                        row.spans.map((ageSpan) => (
                          <TableCell key={ageSpan.id} align='right'>
                            {ageSpan.name === '*' ? t('statistics:ageAndGenderDistribution.unknown') : ageSpan.name}
                          </TableCell>
                        ))}
                      <TableCell align='right'>{t('statistics:ageAndGenderDistribution.average')}</TableCell>
                      <TableCell align='right'>{t('statistics:ageAndGenderDistribution.count')}</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {row.rows &&
                      row.rows.length > 0 &&
                      row.rows.map((item) => (
                        <TableRow
                          key={item.id}
                          sx={{
                            '& th': { fontWeight: 600, borderBottom: (v) => `1px solid ${v.palette.divider}` },
                          }}
                        >
                          <TableCell>{item.name}</TableCell>
                          <TableCell align='right'>{item.sex === '*' ? t('statistics:ageAndGenderDistribution.unknown') : item.sex}</TableCell>
                          {item.ageSpans &&
                            item.ageSpans.length > 0 &&
                            item.ageSpans.map((ageSpan) => (
                              <TableCell key={ageSpan.id} align='right'>
                                {ageSpan.count}
                              </TableCell>
                            ))}
                          <TableCell align='right'>{item.average}</TableCell>
                          <TableCell align='right'>{sumOfSubRow(item)}</TableCell>
                        </TableRow>
                      ))}
                    {dataList.localAss_id && dataList.localAss_id > 0 && (
                      <TableRow
                        sx={{
                          '& th': { fontWeight: 600, borderBottom: (v) => `1px solid ${v.palette.divider}` },
                        }}
                      >
                        <TableCell>{t('statistics:ageAndGenderDistribution.sum')}</TableCell>
                        <TableCell />
                        {row.sums && row.sums.length > 0 && row.sums.map((sum) => <TableCell align='right'>{sum}</TableCell>)}
                        <TableCell align='right'>{row.averageAge}</TableCell>
                        <TableCell align='right'>{(row.rows ?? []).reduce((tot, x) => tot + (x?.sum ?? 0), 0)}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              );
            })}
        </>
      ) : (
        <Typography variant='h5' align='center' sx={{ color: 'grey.500' }} gutterBottom>
          {t('common:statusMessages.noResult')}
        </Typography>
      )}
    </>
  );
};
